import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MCConfigService } from '@maslul/common-services';

@Injectable()
export class ConfigService extends MCConfigService {
    override appPrefix: string = 'MI';
    protected override http = inject(HttpClient);

    constructor() {
        super(inject(HttpClient));
    }

    declare config: any;

    override load(url: string) {
        return new Promise<void>((resolve) => {
            this.http.get(url).pipe(
            )
                .subscribe((config) => {
                    this.config = config;
                    if (this.config.rootSiteUrl.includes('t.')) {
                        this.config.rootSiteUrl = window.location.host.includes('t.') ?
                            this.config.rootSiteUrl :
                            this.config.rootSiteUrl.toString().replace('t.', 'a.')
                    }
                    resolve();
                });
        });

    }

    override  getConfiguration(): any {
        if (!this.config) {
            throw Error('Config file not loaded!');
        }
        return this.config;
    }

    override setBaseApiUrl(urlSettings: { serviceName: string, baseControllerUrl: string }) {
        let k8sUrl = this.getConfiguration().k8sUrl;

        if (k8sUrl == null || k8sUrl == undefined || k8sUrl.toString() == "") {
            k8sUrl = this.getConfiguration().rootSiteUrl;
        }
        urlSettings.baseControllerUrl =
            k8sUrl.toLowerCase().indexOf('cio.gov.il') > -1 ?
                '' : 'Api/MI' + urlSettings.serviceName + '/';

        return k8sUrl.toString().replace("{service}", urlSettings.serviceName);
    }

    getIsNoValidCheck(): boolean {
        return this.config.noValidCheck == "true";
    }
}
